'use strict';
import './structure/adjustVh';
import './structure/adjustViewport';
import NavEvent from './components/NavEvent';
import InViewEvent from './components/inViewEvent';
import MovieEvent from './components/MovieEvent';
document.addEventListener('DOMContentLoaded', () => {
  const navEvent = new NavEvent();
  const inViewEvent = new InViewEvent();
  const movieEvent = new MovieEvent();

  if (document.querySelector('.l_contentSlashTopPageUnder')) {
    const topSlash = document.querySelector('.l_contentSlashTopPageUnder');
    function adjustTopSlash() {
      let topSlashHeight = topSlash.offsetHeight;
      topSlash.style.top = `-${topSlashHeight}px`;
    }
    window.addEventListener('resize', () => {
      adjustTopSlash();
    });
    adjustTopSlash();
  }

  if (document.querySelector('.l_contentSlashUnderFooter')) {
    const footerSlash = document.querySelector('.l_contentSlashUnderFooter');
    function adjustFooterSlash() {
      let elementHeight = footerSlash.offsetHeight;
      footerSlash.style.top = `-${elementHeight}px`;
    }
    window.addEventListener('resize', () => {
      adjustFooterSlash();
    });
    adjustFooterSlash();
  }
});
